import { useEffect } from 'react';
import { API_URL } from './index';

const Interceptors = () => {
    useEffect(() => {
        API_URL.interceptors.request.use((config) => {
            config.timeout = 30000;
            
            return config;
        });

        API_URL.interceptors.response.use(
            response => response,
            error => {
                if (error.response?.data?.message) {
                    if (error.config.url !== 'token') {
                        return error.response;
                    }
                }

                if (error?.response?.status === 500) {
                    return null;
                }
    
                return Promise.reject(error);
            }
        );
    }, []);
  
    return null;
};

export default Interceptors;